import type { RecommendModels } from '@algolia/recommend';
import type { ReactElement } from 'react';

import { RecentlyViewedWrapper } from './RecentlyViewedWrapper';
import { YouMayAlsoLikeWrapper } from './YouMayAlsoLikeWrapper';
import type { ProductRecommendations as RecommendationsSchema } from '~/amplienceTypes/schemas/imported/product-recommendations-schema';
import { useStaticContext } from '~/utilities/context/static/StaticContext';
import type { Recommendations as RecommendationsTypes } from '~/utilities/graphql/codegen';

export type RecommendationsProps = {
  recommendations?: RecommendationsTypes | null;
  ariaRole?: string;
  ariaLabel?: string;
  className?: string;
  model?: RecommendModels;
  onReady?: (hasProducts: boolean) => void;
};

export const Recommendations = (props: RecommendationsSchema): ReactElement | null => {
  const { sectionName } = props;
  const { accessibilityLabels } = useStaticContext();

  switch (sectionName) {
    case 'recently viewed':
      return <RecentlyViewedWrapper {...props} aria-label={accessibilityLabels?.rv} />;
    case 'you may also like':
      return <YouMayAlsoLikeWrapper {...props} ariaLabel={accessibilityLabels?.ymal} />;
    default:
      return null;
  }
};
